export const GET_GLOBAL_CONFIG_DATA = "config/GET_GLOBAL_CONFIG_DATA"
export const SET_GLOBAL_CONFIG_DATA = "config/SET_GLOBAL_CONFIG_DATA"
export const GET_GLOBAL_CONFIG_DATA_FAILED =
    "config/GET_GLOBAL_CONFIG_DATA_FAILED"
